import React from 'react'

function Who() {
    return (
        <div className="who">
            <div className="who-content1">
                <h1>Who we are</h1>
                <p>
                    Job hunting can be stressful and in most cases extremely
                     frustrating, don’t you think? We think so too, 
                     one could even describe it as a full-time job 
                     in itself; the filling of countless forms, 
                     enlisting your skill-set over and over again, 
                     having to retype why you think you are a good 
                     fit for the role, deciding a salary range…It never ends!
                </p>
                <p>
                    Amazingly, ApplyForMe is here to help. ApplyforMe is 
                    a reverse recruiting agency and we are here to assist 
                    you in performing job search, applying to jobs, and 
                    finding interviews perfect to your job description.
                </p>
            </div>
            <div className="who-content2">
                <img src="./img/unsplash_S3GrMiUhpNU.jpg" alt="" />
            </div>
        </div>
    )
}

export default Who
